import { render, staticRenderFns } from "./LanguagesPanel.vue?vue&type=template&id=330b9793"
import script from "./LanguagesPanel.vue?vue&type=script&lang=js"
export * from "./LanguagesPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports